
import {
  Container,
  List,
  ListItem,
  LinkNav,

  IconStatistics,
  ListBox,
  TitleName,
  ImgTitle,
  IconSettings,
  IconServices,
  IconHome,
  IconFinance,
  PreImg,
  TitleBox,
  Text1,
  IconBook,
} from './UserNav.styled';

import { useLocation } from 'react-router-dom';
import LogoutBtn from '../LogoutBtn';

import { selectUser } from '../../../redux/auth/selectors';
import { useSelector } from 'react-redux';
import { getInitial } from 'utils/function';
import { useEffect, useState } from 'react';


const UserNav = ({ closeSidebar, isHovered, onboard }) => {

  const [merchant, setMerchant] = useState();
  const user = useSelector(selectUser);
  useEffect(() => { if (user) { setMerchant(user.merchant) } }, [user])

  const location = useLocation();

  /* eslint-disable */
  const [_, currentPage] = location.pathname.split('/');
  /* eslint-enable */

  return (
    <Container>
      <TitleBox>{merchant?.logo ? <ImgTitle src={merchant.logo} alt="лого" /> : <PreImg>{getInitial(merchant?.name)}</PreImg>} {isHovered || onboard ? <TitleName>{merchant?.name} </TitleName> : null}</TitleBox>
      <ListBox>

        <List>

          <ListItem className={`${currentPage === 'main' ? 'active' : ''} ${isHovered || onboard ? 'hovered' : ''} `}>
            <LinkNav
              onClick={closeSidebar}
              to="/calendar"
              className={`${currentPage === 'main' ? 'active' : ''} text `}
            >
              <IconHome
                isactive={currentPage === 'main' ? 'active' : ''}
                className={`icon ${isHovered || onboard  ? 'hovered' : ''}`}
              />
              {isHovered || onboard  ? <Text1>Головна</Text1> : ""}
            </LinkNav>
          </ListItem>
          <ListItem className={`${currentPage === 'menu' ? 'active' : ''} ${isHovered || onboard ? 'hovered' : ''} `}>
            <LinkNav
              onClick={closeSidebar}
              to={`/menu/${merchant?.shops[0]?.id?merchant?.shops[0]?.id:''}`}
              className={`${currentPage === 'menu' ? 'active' : ''} text `}
            >
              <IconBook
                isactive={currentPage === 'menu' ? 'active' : ''}
                className={`icon ${isHovered || onboard ? 'hovered' : ''}`}
              />
              {isHovered || onboard ? <Text1>Меню</Text1> : ""}
            </LinkNav>
          </ListItem>
          <ListItem className={`${currentPage === 'statistics' ? 'active' : ''} ${isHovered || onboard ? 'hovered' : ''}`}>
            <LinkNav
              onClick={closeSidebar}
              to="/statistics"
              className={`${currentPage === 'statistics' ? 'active' : ''} text`}
            >
              <IconStatistics
                isactive={currentPage === 'statistics' ? 'active' : ''}
                className={`icon ${isHovered || onboard ? 'hovered' : ''}`}
              />

              {isHovered || onboard ? <Text1>Статистика</Text1> : ""}
            </LinkNav>
          </ListItem>
          <ListItem className={`${currentPage === 'financial' ? 'active' : ''} ${isHovered || onboard ? 'hovered' : ''}`}>
            <LinkNav
              onClick={closeSidebar}
              to="/financial"
              className={`${currentPage === 'financial' ? 'active' : ''} text`}

            >
              <IconFinance
                isactive={currentPage === 'financial' ? 'active' : ''}
                className={`icon ${isHovered || onboard ? 'hovered' : ''}`}
              />

              {isHovered || onboard ? <Text1>Фінанси</Text1>: ""}
            </LinkNav>
          </ListItem>
        </List>
        <List>
          <ListItem className={`${currentPage === 'services' ? 'active' : ''} ${isHovered || onboard ? 'hovered' : ''}`}>
            <LinkNav
              onClick={closeSidebar}
              to="/services"
              className={`${currentPage === 'services' ? 'active' : ''} text`}
            >
              <IconServices
                isactive={currentPage === 'services' ? 'active' : ''}
                className={`icon ${isHovered || onboard ? 'hovered' : ''}`}
              />

              {isHovered || onboard ? <Text1>Служба підтримки</Text1>: ""}
            </LinkNav>
          </ListItem>
          <ListItem className={`${currentPage === 'settings' ? 'active' : ''} ${isHovered || onboard ? 'hovered' : ''}`}>
            <LinkNav
              onClick={closeSidebar}
              to="/settings"
              className={`${currentPage === 'settings' ? 'active' : ''}  text`}
            >
              <IconSettings
                isactive={currentPage === 'settings' ? 'active' : ''}
                className={`icon ${isHovered || onboard ? 'hovered' : ''}`}
              />

              {isHovered || onboard ? <Text1>Налаштування</Text1> : ""}
            </LinkNav>
          </ListItem>
          <ListItem className={` ${isHovered || onboard ? 'hovered nvisible' : 'nvisible'}`} none={true} >
            <LogoutBtn isHovered={isHovered} onboard={onboard} />
          </ListItem>
        </List>

      </ListBox>
    </Container>
  );
};

export default UserNav;
